// extracted by mini-css-extract-plugin
export default {"facetSearchContainer":"facetSearchContainer---ZJrQc","facetSearch":"facetSearch---Ub7yL","moreIcon":"moreIcon---MvLSA"};